export default "__VITE_ASSET__5aLOxNkO__"